var counters = {
    init: function() {
        var self = this;
        self.counters();
    },

    formatNumber: function(number) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "’");
    },

    observerCallback: function(entries, observer) {
        var self = this;
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const target = parseInt(entry.target.getAttribute("data-counter"), 10);
                const speed = parseInt(entry.target.getAttribute("data-speed"), 10);
                self.animateCounter(entry.target, target, speed);
                observer.unobserve(entry.target);
            }
        });
    },

    animateCounter: function(element, target, duration) {
        var self = this;
        let start = 0;
        let startTime = null;

        function updateCounter(timestamp) {
            if (!startTime) startTime = timestamp;
            const progress = timestamp - startTime;
            const progressPercentage = Math.min(progress / duration, 1);
            const current = Math.floor(progressPercentage * target);

            element.textContent = self.formatNumber(current);

            if (progress < duration) {
                requestAnimationFrame(updateCounter);
            } else {
                element.textContent = self.formatNumber(target);
            }
        }

        requestAnimationFrame(updateCounter);
    },

    counters: function() {
        var self = this;
        const observerOptions = {
            root: null,
            rootMargin: "0px",
            threshold: 0.1
        };

        const observer = new IntersectionObserver(function(entries, observer) {
            self.observerCallback(entries, observer);
        }, observerOptions);

        const counters = document.querySelectorAll("[data-counter]");
        counters.forEach(counter => {
            observer.observe(counter);
        });
    }
};

// Export the counters object
export { counters };